var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { useDropzone } from "react-dropzone";
export var fileId = function (file) {
    return "".concat(file.name, "_").concat(file.type, "_").concat(file.size, "_").concat(file.lastModified);
};
/**
 *
 * @param param0 Type: image pour les photo et file pour les autres type
 * @returns
 */
export default function UploadFile(_a) {
    var labelUpload = _a.labelUpload, type = _a.type, //image ou file pour les autres types
    onEntriesDroped = _a.onEntriesDroped, className = _a.className;
    var onDrop = useCallback(function (acceptedFiles) {
        var uploads = new Map();
        var fileLoadingPromises = acceptedFiles.map(function (file) {
            return new Promise(function (resolve, reject) {
                var entry = undefined;
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function (e) {
                    var _a;
                    var result = ((_a = e.target) === null || _a === void 0 ? void 0 : _a.result) || "";
                    //const base64Content = result;
                    var base64Content = result === null || result === void 0 ? void 0 : result.split(",")[1];
                    entry = {
                        id: "",
                        name: file.name || "",
                        type: file.type,
                        file: file,
                        content: base64Content,
                        size: file.size,
                        lastModified: file.lastModified,
                    };
                    if (entry) {
                        var fId = fileId(entry);
                        if (!uploads.has(fId)) {
                            uploads.set(fId, entry);
                            resolve(true);
                        }
                    }
                    resolve(false);
                };
                reader.onerror = function () {
                    resolve(false);
                };
            });
        });
        Promise.all(fileLoadingPromises).then(function () {
            onEntriesDroped && onEntriesDroped(Array.from(uploads.values()));
        });
    }, [onEntriesDroped]);
    var _b = useDropzone({
        onDrop: onDrop,
        noClick: true,
    }), getRootProps = _b.getRootProps, getInputProps = _b.getInputProps;
    var handleSelectClick = function () {
        var input = document.createElement("input");
        var isPhoto = type === "image";
        input.setAttribute("type", "file");
        input.setAttribute("accept", isPhoto ? "image/*" : "*");
        input.setAttribute("multiple", "");
        input.onchange = function (event) {
            var selectedFiles = Array.from(event.target.files);
            if (selectedFiles.length > 0) {
                onDrop(selectedFiles);
            }
        };
        input.click();
    };
    return (_jsxs("div", __assign({}, getRootProps(), { className: "border-2 rounded border-dotted min-w-[100px] flex ".concat(className ? className : "justify-center", " items-center h-[50px] cursor-pointer  px-2"), onClick: handleSelectClick }, { children: [_jsx("input", __assign({}, getInputProps())), _jsx("span", __assign({ className: "border border-black flex   items-center p-1 whitespace-nowrap " }, { children: labelUpload }))] })));
}
